import React, { useEffect, useState, useRef } from 'react';
import { NylasScheduling } from '@nylas/react';
import { create } from 'apisauce';
import { Loading } from 'components/Loading';
import NotFound from 'pages/NotFound';
import { observeShadowRoots, applyStyles } from 'components/Scheduler/utils/shadowRoot';
import { localSchedulerPreviewRootStyle } from 'components/Scheduler/injected-scheduler-style';
import { SCHEDULER_THEME_STYLES } from 'components/Scheduler/constants';

import './scheduler.scss';

const STYLED_SHADOW_ELEMENTS = [
  'nylas-scheduling',
  'nylas-notification',
  'nylas-selected-event-card',
  'nylas-booking-form',
  'input-component',
  'radio-button-group',
  'checkbox-component',
  'select-dropdown',
  'multi-select-dropdown',
  'button-component',
  'nylas-cancel-booking-form',
  'nylas-cancelled-event-card',
];
const OBSERVABLE_SHADOW_ELEMENTS = [
  'nylas-booking-form',
  'nylas-scheduling',
];

const Scheduler = ({ configurationId, error }) => {
  const [showNylasScheduling, setShowNylasScheduling] = useState(false);
  const [logo, setLogo] = useState();
  const [notFound, setNotFound] = useState(false);
  const [showError, setShowError] = useState(false);
  const componentRef = useRef();

  const getSchedulerUiSettings = async () => {
    const api = create({
      baseURL: 'https://api.us.nylas.com/v3/scheduling',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    try {
      const response = await api.get(`/ui-settings?configuration_id=${configurationId}`);
      if (response.status === 200) {
        setShowNylasScheduling(true);
        const { data } = response.data;
        const { scheduler } = data || {};
        const { email_template } = scheduler || {};
        const { logo: _logo } = email_template || {};
        if (_logo) setLogo(_logo);
      } else if (response.status === 404) {
        setNotFound(true);
      } else {
        setShowError(true);
      }
    } catch {
      setShowError(true);
    }
  };

  useEffect(() => {
    if (configurationId && !error) {
      getSchedulerUiSettings();
    }
  }, [configurationId]);

  const updateLocalShadowRoots = () => {
    if (!componentRef?.current) return;

    observeShadowRoots(componentRef.current, (element) => {
      const tagName = element.tagName.toLowerCase();
      if (STYLED_SHADOW_ELEMENTS.includes(tagName)) {
        applyStyles(element, null, localSchedulerPreviewRootStyle);
      }
    }, OBSERVABLE_SHADOW_ELEMENTS);
  };

  const scheduleShadowUpdates = () => {
    // A small delay so that the DOM has time to update.
    setTimeout(() => {
      updateLocalShadowRoots();
    }, 0);
  };

  if (!configurationId && !error) {
    return (
      <Loading />
    );
  }

  if (notFound || error || showError || configurationId === 0) {
    return <NotFound />;
  }

  return (
    <>
      <div className="scheduler__header">
        {logo && (
          <img
            src={logo}
            className="company-logo"
          />
        )}
      </div>
      {showNylasScheduling && (
        <NylasScheduling
          ref={componentRef}
          configurationId={configurationId}
          enableUserFeedback={false}
          nylasBranding={false}
          themeConfig={SCHEDULER_THEME_STYLES}
          eventOverrides={{
            timeslotConfirmed: async () => {
              scheduleShadowUpdates();
            },
          }}
        />
      )}
    </>
  );
};

export default Scheduler;
